import NetworkingOperations from "../index";

const PaymentVoucher = (data) => {
	const url = process.env.REACT_APP_PAYMENT_VOUCHER;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentVoucher;
